import { usePage } from "@inertiajs/react"
import { Sparkles } from "lucide-react"

import { AgentChatSheet } from "@/components/agent-chat/agent-chat-sheet"
import { Breadcrumbs } from "@/components/breadcrumbs"
import { Button } from "@/components/ui/button"
import { SidebarTrigger } from "@/components/ui/sidebar"
import type { BreadcrumbItem as BreadcrumbItemType } from "@/types"

export function AppSidebarHeader({
  breadcrumbs = [],
}: {
  breadcrumbs?: BreadcrumbItemType[]
}) {
  const { finance_agent } = usePage().props

  return (
    <header className="border-sidebar-border/50 flex h-16 shrink-0 items-center justify-between gap-2 border-b px-6 transition-[width,height] ease-linear group-has-data-[collapsible=icon]/sidebar-wrapper:h-12 md:px-4">
      <div className="flex items-center gap-2">
        <SidebarTrigger className="-ml-1" />
        <Breadcrumbs breadcrumbs={breadcrumbs} />
      </div>
      {finance_agent.enabled && (
        <AgentChatSheet>
          <Button
            type="button"
            variant="ghost"
            size="icon"
            aria-label="Open finance assistant"
          >
            <Sparkles />
          </Button>
        </AgentChatSheet>
      )}
    </header>
  )
}
